module.exports = __webpack_public_path__ + "static/lingraphic-50a863822b570ed167b6ab718d28bb61.png";